import { render, staticRenderFns } from "./BreakDeposit.vue?vue&type=template&id=7050b4c2"
import script from "./BreakDeposit.vue?vue&type=script&lang=js"
export * from "./BreakDeposit.vue?vue&type=script&lang=js"
import style0 from "./BreakDeposit.vue?vue&type=style&index=0&id=7050b4c2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports